import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { BoletimContext } from '../context/BoletimContext';
import { canEditBoletim, hasPermission } from '../Utils/permissions';

export default function BoletimEditGuard({ children }) {
  const { boletim } = useContext(BoletimContext);
  if (canEditBoletim(boletim)) return children;
  return <div role="alert" className="container mt-4">
    <p>Acesso negado. Sua conta não pode editar este boletim.</p>
    {boletim?._id && (hasPermission('boletins.view.all') || hasPermission('boletins.view.own')) &&
      <Link to={`/boletins/${encodeURIComponent(boletim._id)}`}>Voltar à visualização</Link>}
  </div>;
}
